<template>
  <div class="presentation">
    <div class="name-bar">
      <div class="logo"><img src="@/assets/yd-logo.svg" alt="logo"></img></div>
      <span class="ch-name">杨端正旭</span><span class="en-name">Victor Yangd</span>
    </div>
    <div class="catalogue">
      <ul>
        <li @mouseenter="handleSwitchCover(0)" @click="goToPage(0)">Aquarium</li>
        <li @mouseenter="handleSwitchCover(1)" @click="goToPage(1)">Architecture</li>
        <li @mouseenter="handleSwitchCover(2)" @click="goToPage(2)">Green Nature</li>
        <li @mouseenter="handleSwitchCover(3)" @click="goToPage(3)">Road View</li>
        <li @mouseenter="handleSwitchCover(4)" @click="goToPage(4)">Night Scene</li>
      </ul>
    </div>
    <div class="column-bar">
      <span id="about" @click="goToPage(5)">About</span>
      |
      <span id="contact" @click="goToPage(6)">Contact</span>
      |
      <span id="produce" @click="goToPage(7)">Produce</span>
    </div>
  </div>

  <div class="cover-board">
    
    <img 
      class="background" 
      :class="{ active: currentIndex === index }" 
      v-for="(image, index) in coverImages" 
      :key="index" 
      :src="image" 
      alt="cover"
      @load="handleImageLoad"
    >
  </div>
</template>

<script>
export default{
  name:'home',
  data(){
    return{
      currentIndex: 0,
      coverImages: [
        require('../assets/covers/封面0.jpg'),
        require('../assets/covers/封面1.jpg'),
        require('../assets/covers/封面2.jpg'),
        require('../assets/covers/封面3.jpg'),
        require('../assets/covers/封面4.jpg')      
      ],
      imagesLoaded: false,
      switchTimeout: null
    }
  },
  mounted() {
    this.preloadImages();
  },
  methods:{
    // 图片预加载
    preloadImages() {
      const loadPromises = this.coverImages.map(src => {
        return new Promise((resolve) => {
          const img = new Image();
          img.src = src;
          img.onload = resolve;
          img.onerror = resolve;
        });
      });
      
      Promise.all(loadPromises).then(() => {
        this.imagesLoaded = true;
      });
    },
    
    // 防抖切换
    handleSwitchCover(index) {
      if (!this.imagesLoaded) return;
      
      // 清除之前的定时器
      if (this.switchTimeout) {
        clearTimeout(this.switchTimeout);
      }
      
      // 设置新的切换
      this.switchTimeout = setTimeout(() => {
        if (index !== this.currentIndex) {
          this.currentIndex = index;
        }
      }, 50); // 50ms防抖
    },
    
    handleImageLoad() {
      console.log('Image loaded successfully');
    },
    goToPage(index){
      const routeMap = [
        '/aquarium',      // 索引0：水族馆
        '/architecture',  // 索引1：建筑
        '/green-nature',  // 索引2：苍绿自然
        '/road-view',     // 索引3：路边风光
        '/night-scene',   // 索引4：夜色
        '/about',
        '/contact',
        '/produce'
      ];
      if (index === 5 || index ===6 || index ===7) {
        this.$router.push({
          path: routeMap[index],
          query: { bgIndex: this.currentIndex }
        });
      } else {
        this.$router.push(routeMap[index]);
      }
    }
  }
}
</script>

<style>
:root{
  --catalogue-gap:20vh;
  --ch-name-fontsize:calc(max(2vw,30px));
  --logo-size:calc(var(--ch-name-fontsize)*1.5);
  --en-name-fontsize:calc(var(--ch-name-fontsize)*0.8);
  --en-name-margin-left:1vw;
  --li-fontsize: calc(var(3vw)/3*1.5);
  --dot-size:0.8vw;
  --name-direction:row;
  --column-fontsize:22px;
  --logo-margin-left:0;
  --column-margin-top:5vh;
}

@media (max-width: 900px) {
  :root{
    --ch-name-fontsize:20px;
    --logo-size:calc(var(--ch-name-fontsize)*4);
    --li-fontsize: 24px;
    --en-name-fontsize:calc(var(--ch-name-fontsize)*0.5);
    --en-name-margin-left:0vw;
    --name-direction:column;
    --column-fontsize:18px;
    --logo-margin-left:5vw;
  }
}

@media (min-height: 1200px) {
    :root{
      --ch-name-fontsize:4vh;
      
    }
}
    
</style>


<style scoped>
.cover-board {
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  height: 100%;
  background-color: black;
  overflow: hidden;
  /* 创建新的图层 */
  isolation: isolate;
}

.background {
  position: absolute;
  left: 70%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  height: 100%;
  object-fit: cover;
  opacity: 0;
  /* 简化过渡效果，只保留opacity */
  transition: opacity 0.6s ease-in-out;
  /* 使用性能更好的mask */
  mask-image: linear-gradient(to left, black 50%, transparent 100%);
  -webkit-mask-image: linear-gradient(to left, black 50%, transparent 100%);
  /* 提升GPU加速 */
  will-change: opacity, transform;
  /* 防止图片拖动 */
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
  user-drag: none;
}

.background.active {
  opacity: 1;
  /* 移除复杂的transform变化 */
}

/* 移除不必要的非激活状态样式 */
.background:not(.active) {
  /* 保持简单 */
}
.goto{
  
  position: fixed;
  right:10vw;
  bottom:10vh;
  /* font-size:5vw; */
  color:white;
  z-index: 3;
  
  
}
/* .line{
  display: flex;
  flex-direction: column;
} */
.presentation{
  position: fixed;
  display: flex;
  height:100%;
  flex-direction: column;
  align-items: flex-start;
  color:#ccc;
  font-size:var(--ch-name-fontsize);
  /* font-size: clamp(20px, var(--ch-name-fontsize), 100px); */
  /* min-font-size:20px; */
  margin-top:5vh;
  margin-left:4vw;
  z-index: 2; /* 提高z-index确保在最上层 */
  /* gap:var(--catalogue-gap); */
  /* 提升渲染性能 */
  will-change: transform;
}
.name-bar{
  display: flex;
  align-items: center;
  margin-left:var(--logo-margin-left);
  flex-direction: var(--name-direction);
}
.logo{
  position: relative;

  left:-1vw;
  /* top:5vh; */
  width:var(--logo-size);
  height:var(--logo-size);
  z-index: 10;
}
.logo img{
  filter: invert(1);
  width:100%;
  height:100%;
  /* z-index: 10; */
    /* 防止图片拖动 */
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
  user-drag: none;
  /* 可选：禁止选中图片 */
  user-select: none;
  -webkit-user-select: none;
}
.en-name{
  margin-left:var(--en-name-margin-left);
  letter-spacing: 0.3vw;
  font-size: var(--en-name-fontsize);
  color: #ffffffe0;
  font-family:serif;
  font-weight: 100;
}

.catalogue{
  margin-top:20vh;
  font-size:var(--li-fontsize);
  margin-left: 3.5vw;
  -webkit-tap-highlight-color: transparent;
  tap-highlight-color: transparent;
}

.catalogue ul{
  list-style:none;
  margin: 0;
  padding: 0;
}

.catalogue li{
  margin-top: 1vh;
  transition: transform 0.3s ease, color 0.3s ease;
  cursor: pointer;
  position: relative;
  padding-left: 0;
  /* 优化文字渲染 */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.catalogue li:hover{
  transform: scale(1.05);
  color: white;
  padding-left: 1vw;
}

.catalogue li::before {
  content: '';
  position: absolute;
  left: -1.5vw;
  top: 50%;
  transform: translateY(-50%);
  width: var(--dot-size);
  height: var(--dot-size);
  background-color: white;
  border-radius: 50%;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.catalogue li:hover::before {
  opacity: 1;
}

/* 媒体查询针对性能较差的设备 */
@media (max-width: 768px) {
  .background {
    transition: opacity 0.4s ease-in-out;
  }
  
  .atalogue li {
    transition: color 0.3s ease; /* 移除transform以提升性能 */
  }
  
  .atalogue li:hover {
    transform: none; /* 移动端移除缩放效果 */
  }
}

.column-bar{
  position:relative;
  /* margin-left: 4vw; */
  margin-left: 2.5vw;
  margin-top: var(--column-margin-top);
  margin-bottom: 5vh;
  color:#ccc;
  width: fit-content;
  font-size: var(--column-fontsize);
  z-index:5;
  -webkit-tap-highlight-color: transparent;
  tap-highlight-color: transparent;
}
.column-bar span{
  margin:0 0.5vw;
  cursor:pointer;
}
.column-bar span:hover{
  /* transform: scale(1.5); */
  color: white;
}
</style>